import { clientServer } from "duck/api/axios";

interface GenericGetRequest {
  url: string;
}

// Fetch as a Blob so the server's exact bytes (including the UTF-8 BOM that lets
// Excel open Japanese CSVs without mojibake) survive to the download. Decoding to
// a string strips the BOM.
export const getContentRequest = async (
  { url }: GenericGetRequest,
  mediaType: string
): Promise<Blob> => {
  const path = clientServer.getUri({
    method: "GET",
    url,
  });

  const res = await clientServer.get<Blob>(path, {
    headers: { Accept: mediaType },
    responseType: "blob",
  });

  return res.data;
};
